module.exports = __webpack_public_path__ + "static/media/aeronave.0da10ec5.glb";